import { Skeleton, SxProps, Theme } from "@mui/material";
import React from "react";

type Props = {
  styles?: SxProps<Theme>;
};

export const CustomSkeleton = ({ styles }: Props) => {
  return (
    <Skeleton
      data-testid="custom-skeleton"
      animation="wave"
      variant="rectangular"
      sx={{ transformOrigin: 0, borderRadius: "6px", ...styles }}
    />
  );
};
